import type { LocalizationErrorMap } from '@/shared/model/types/api-types';

export type AppSettings = {
  languageCode: string;
  siteUrl?: string;
  auth?: {
    username: string;
    spa_id: number;
  };
  wsauthHost: string;
  glossUrl: string;
  replayMaxSize: number;
  commonMenuSrc: string;
  commonMenuDataRegistrationUrl: string;
  commonRealm: string;
  commonMenuDataBackendUrl: string;
  localizationErrorRu?: LocalizationErrorMap;
};

export type Link = {
  name: string;
  link: string;
};

export enum BattleDetailsType {
  Numeric,
  Ribbon,
  Achievement,
}

export type Social = {
  description: string;
  href: string;
  icon: string;
  type: string;
};

export type LevelType = string;

export enum ImageType {
  Ship,
  Icon,
  Social,
  Toast,
  Guide,
  Stats,
}
